module.exports = {
	"author": "DigixGlobal",
	"title": "Blocktime based access control",
	"fileName": "contracts/ACDates.sol",
	"name": "ACDates",
	"abi": [],
	"bin": "6060604052346000575b60358060166000396000f30060606040525b60005600a165627a7a7230582041d40fdacbb8818f9f46ccc67a7554fa4e647eca8186be2fcd2d481acfd4adaa0029",
	"opcodes": "PUSH1 0x60 PUSH1 0x40 MSTORE CALLVALUE PUSH1 0x0 JUMPI JUMPDEST PUSH1 0x35 DUP1 PUSH1 0x16 PUSH1 0x0 CODECOPY PUSH1 0x0 RETURN STOP PUSH1 0x60 PUSH1 0x40 MSTORE JUMPDEST PUSH1 0x0 JUMP STOP LOG1 PUSH6 0x627A7A723058 SHA3 COINBASE 0xd4 0xf 0xda 0xcb 0xb8 DUP2 DUP16 SWAP16 0x46 0xcc 0xc6 PUSH27 0x7554FA4E647ECA8186BE2FCD2D481ACFD4ADAA0029000000000000 ",
	"source": "pragma solidity ^0.4.6;\n\n/// @title Blocktime based access control\n/// @author DigixGlobal\n\ncontract ACDates {\n\n    modifier ifBefore(uint256 _date) {\n        if (now > _date) {\n            throw;\n        } else {\n            _;\n        }\n    }\n\n    modifier ifAfter(uint256 _date) {\n        if (now < _date) {\n            throw;\n        } else {\n            _;\n        }\n    }\n}\n",
	"abiDocs": []
};


//////////////////
// WEBPACK FOOTER
// ./docs/ACDates.json
// module id = 1066
// module chunks = 0